export default "/images/timeout.svg"